import logo from './beesLogo.svg'
import polygon from './polygon.svg'

export const BeesLogo = logo
export const PolygonImg = polygon
